import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import UIMenuBody, { filterSelectedItem } from '../../../../components/UI/UIMenuBody';
import { AFFILIATES_AGENTS_TAB, AFFILIATES_INFO_TAB, AFFILIATES_INVITE_CODES_TAB } from '../../../../utils/Config/MenuBodyTabs';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_SALESPERSON } from './queries';
import IndividualSalespersonInfoTab from './IndividualSalespersonTabs/IndividualSalespersonInfoTab';
import IndividualSalespersonAgentsTab from './IndividualSalespersonTabs/IndividualSalespersonAgentsTab';
import IndividualSalespersonInviteCodesTab from './IndividualSalespersonTabs/IndividualSalespersonInviteCodesTab';
import * as strings from './strings';

export default function IndividualSalesperson({}) {
	const match = useRouteMatch<MatchRouteType>();
	const location = useLocation();

	const [salesperson, setSalesperson] = useState<UserType>();

	const [getSalesperson, { data: salespersonData }] = useLazyQuery(GET_SALESPERSON, {
		variables: { id: match.params.id }
	});

	useEffect(() => {
		(async () => {
			await getSalesperson();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (salespersonData) {
				setSalesperson(salespersonData['user']);
			}
		})();
	}, [salespersonData]);

	// Mark: Lifecycle functions
	if (!salesperson) return null;

	//Mark: Component functions

	let tabs = [AFFILIATES_INFO_TAB, AFFILIATES_AGENTS_TAB, AFFILIATES_INVITE_CODES_TAB];

	const renderSelectedPage = () => {
		const selectedPage = filterSelectedItem(tabs, location);
		switch (selectedPage) {
			case AFFILIATES_INVITE_CODES_TAB:
				return <IndividualSalespersonInviteCodesTab salespersonId={salesperson.id} />;
			case AFFILIATES_AGENTS_TAB:
				return <IndividualSalespersonAgentsTab salespersonId={salesperson.id} />;
			case AFFILIATES_INFO_TAB:
				return <IndividualSalespersonInfoTab salespersonId={salesperson.id} />;
			default:
				return null;
		}
	};

	//Mark: Render functions

	return (
		<UIMenuBody menuTitle={salesperson.name} menuItems={tabs}>
			<>
				<Helmet>
					<title>
						{salesperson.name} {strings.pineappleLabsTitle}
					</title>
					<meta property='og:title' content={`${salesperson.name} ${strings.pineappleLabsTitle}`} />
				</Helmet>
				{renderSelectedPage()}
			</>
		</UIMenuBody>
	);
}
